// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"717c556f","80":"0c9a2b0c","192":"55a907a8","365":"51be4586","453":"1407b060","651":"6e661dac","909":"7e9e31d4"}[chunkId] + ".chunk.js";
};